import { render, staticRenderFns } from "./UserAddressAdd.vue?vue&type=template&id=38cf1a7b&"
import script from "./UserAddressAdd.vue?vue&type=script&lang=js&"
export * from "./UserAddressAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserAddressAdd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports